import script from "./BalCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./BalCarousel.vue?vue&type=style&index=0&id=f9f11e30&scoped=true&lang=css"
import "./BalCarousel.vue?vue&type=style&index=1&id=f9f11e30&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9f11e30"]])

export default __exports__